module.exports = __webpack_public_path__ + "nc_static/media/sw-installation-failed.aa8933fe.svg";